(function() {
  var TRANSLATIONS = {
    SELECT_SHAPE: "IZBERITE OBLIKO",
    SELECT_BLADE: "IZBERITE REZILO",
    SELECT_HANDLE: "IZBERITE ROČAJ",
    YOUR_SELECTION: "VAŠ IZBOR",
    REMOVE_SELECTION: "Odstrani izbiro",
    CONFIRM_SELECTION: "Potrdi izbiro",
    HANDLING_TITLE: "Montaža ročaja in rezila",
    HANDLING_DESCRIPTION: "Storitev dodajte v voziček, ko pri nas naročite rezilo (nož brez ročaja) in ročaj po meri in želite, da vam namestimo ročaj na rezilo.",
    PREVIEW_TITLE: "KONFIGURATOR - Oblikujte svoj nož",
    BROWSER_NOT_SUPPORTED: "Vaš brskalnik ni podprt. Za dostop do konfiguratorja uporabite Chrome, Edge, Firefox ali Safari.",
    NO_SHAPES: "Na voljo ni nobenih oblik.",
    NO_BLADES: "Ni na voljo rezil za izbrano obliko in/ali velikost ročaja. Poskusite izbrati drugačen ročaj.",
    NO_HANDLES: "Ni na voljo ročajev za izbrano obliko in/ali velikost rezila. Poskusite izbrati drugo rezilo.",
    RESET_CONFIGURATOR: "Ponastavi konfigurator",
    SHAPE: "Oblika",
    BLADE: "Rezilo",
    HANDLE: "Ročaj",
    BUTTON_MORE: "Več",
    VIEW_MORE: "➕ Poglej vse oblike rezil",
    VIEW_LESS: "➖ Pokaži manj",
    ADD_TO_CART: "Dodaj v košarico",
    SOLD_OUT: "Razprodano",
    SAVE_BADGE: "Prihrani",
    SHARE: "Deli svoj personalizirani nož",
    COPIED_TO_CLIPBOARD: "Kopirano v odložišče",
    BLADE_MODAL: {
      DESCRIPTION_TAB_NAME: "Opis",
      SPECIFICATIONS_TAB_NAME: "Specifikacije",
      BLADE_SHAPE: "Oblika rezila",
      STEEL_TYPE: "Jeklo",
      BLADE_CONSTRUCTION: "Konstrukcija",
      HARDNESS: "Trdota (HRC)",
      OVERALL_LENGTH: "Dolžina noža",
      BLADE_LENGTH: "Dolžina rezila",
      BLADE_HEIGHT: "Širina rezila",
      SPINE_THICKNESS: "Debelina rezila",
      WEIGHT: "Teža",
      HANDLE_LENGTH: "Dolžina ročaja",
      HANDLE_TYPE_WOOD: "Vrsta ročaja / les",
      KANJI_ON_THE_BLADE: "Napis na rezilu",
      BLACKSMITH: "Kovač",
      LOCATION_OF_THE_SMITHY: "Lokacija kovačije",
    }
  }

  window.TRANSLATIONS = TRANSLATIONS;
})();